import React, { useLayoutEffect } from 'react';
import {
  Content,
  ContentContainer,
  PageContainer,
  Title,
  BoldText,
  Text,
  StyledSubtitle,
  StyledCallToAction,
  StyledList,
  StyledLi,
} from './Hikes.styles';
import { useTranslation } from 'react-i18next';
import { PhotoGallery } from './PhotoGallery';
import { imagesKarkonosze } from './images';

export const Karkonosze = () => {
  const { t } = useTranslation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const listItems2 = t('tatry2.list1', { returnObjects: true }) as string[];
  return (
    <PageContainer>
      <ContentContainer>
        <Content>
          <Title>{t('hiking.tatry2')}</Title>
          <BoldText>{t('hiking.destination-tatry2')}</BoldText>
          <BoldText>{t('hiking.date-tatry2')}</BoldText>
          <Text> {t('tatry2.description')}</Text>
          <StyledSubtitle>{t('tatry2.subtitle0')}</StyledSubtitle>
          <Text> {t('tatry2.description0')}</Text>
          <StyledSubtitle>{t('tatry2.subtitle1')}</StyledSubtitle>
          <Text>{t('tatry2.description1')}</Text>

          <StyledList>
            {listItems2.map((item: string, index: number) => (
              <StyledLi key={index}>
                <Content>{item}</Content>
              </StyledLi>
            ))}
          </StyledList>
          <StyledSubtitle>{t('tatry2.subtitle2')}</StyledSubtitle>

          <Text>{t('tatry2.description2')}</Text>
          <StyledSubtitle>{t('tatry2.subtitle3')}</StyledSubtitle>

          <Text>{t('tatry2.description3')}</Text>
          <StyledCallToAction>
            <StyledSubtitle> {t('tatry2.cta')}</StyledSubtitle>
          </StyledCallToAction>

          <PhotoGallery images={imagesKarkonosze} />
        </Content>
      </ContentContainer>
    </PageContainer>
  );
};
